import { memo, useMemo, useState } from 'react';
import { CircularProgress, Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

const ProductStatistics = ({ setData }) => {
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const { search } = useLocation();

  const { isLoading, isFetching, isError, data } = useQuery({
    queryKey: ['/analytic/expense/main', search],
    queryFn: async function () {
      const response = await axiosPrivate.get(
        `/analytic/expense/main${search}`
      );
      return response.data.data;
    },

    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  return (
    <div className='residential-complex-item income-by-residential-complex !shadow-md !base-border'>
      <div className='residential-complex-item-header'>
        <div className='residential-complex-item-title font-semibold text-lg income-by-residential-complex-title mb-4'>
          Kirim chiqim statistikasi
        </div>
      </div>

      <Grid container spacing={2} columns={{ xs: 9, sm: 9, md: 9, lg: 9 }}>
        <Grid item={true} lg={3} md={3} sm={12} xs={12}>
          <div className='shadow-md p-2 border rounded-md w-full h-full'>
            {isLoading || isFetching ? (
              <div className='h-48 flex items-center justify-center'>
                <CircularProgress />
              </div>
            ) : (
              <>
                <div className='font-semibold text-center'>Chiqim</div>
                <div className='p-2 border shadow-md mt-2'>
                  UZS:{' '}
                  <CurrencyFormat
                    value={data?.expense?.insum}
                    suffix=''
                    allowNegative
                    decimalScale={2}
                  />
                </div>
                <div className='p-2 border shadow-md mt-2'>
                  USD:{' '}
                  <CurrencyFormat
                    value={data?.expense?.invalute}
                    suffix=''
                    allowNegative
                    decimalScale={2}
                  />
                </div>
                <div className='p-2 border shadow-md mt-2'>
                  Jami USD:{' '}
                  <CurrencyFormat
                    value={data?.expense?.total}
                    suffix=''
                    allowNegative
                    decimalScale={2}
                  />
                </div>
              </>
            )}
          </div>
        </Grid>

        <Grid item={true} lg={3} md={3} sm={12} xs={12}>
          <div className='shadow-md p-2 border rounded-md w-full h-full'>
            {isLoading || isFetching ? (
              <div className='h-48 flex items-center justify-center'>
                <CircularProgress />
              </div>
            ) : (
              <>
                {' '}
                <div className='font-semibold text-center'>Kirim</div>
                <div className='p-2 border shadow-md mt-2'>
                  UZS:{' '}
                  <CurrencyFormat
                    value={data?.income?.insum}
                    suffix=''
                    allowNegative
                    decimalScale={2}
                  />
                </div>
                <div className='p-2 border shadow-md mt-2'>
                  USD:{' '}
                  <CurrencyFormat
                    value={data?.income?.invalute}
                    suffix=''
                    allowNegative
                    decimalScale={2}
                  />
                </div>
              </>
            )}
          </div>
        </Grid>

        <Grid item={true} lg={3} md={3} sm={12} xs={12}>
          <div className='shadow-md p-2 border rounded-md w-full h-full'>
            {isLoading || isFetching ? (
              <div className='h-48 flex items-center justify-center'>
                <CircularProgress />
              </div>
            ) : (
              <>
                <div className='font-semibold text-center'>Balans</div>
                <div className='p-2 border shadow-md mt-2'>
                  UZS:{' '}
                  <CurrencyFormat
                    value={data?.expense?.insum - data?.income?.insum}
                    suffix=''
                    allowNegative
                    decimalScale={2}
                  />
                </div>
                <div className='p-2 border shadow-md mt-2'>
                  USD:{' '}
                  <CurrencyFormat
                    value={data?.expense?.invalute - data?.income?.invalute}
                    suffix=''
                    allowNegative
                    decimalScale={2}
                  />
                </div>{' '}
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(ProductStatistics);
